import React from "react";
import "../../../scss/dashboard.scss";
import { useGetQuickSightOrg } from "./hooks";
import { useStateContext } from "state";
import { Dashboard as AdHocDashboard } from "features/ad-hoc-dashboard/dashboard";
import { Navigate, useSearchParams } from "react-router-dom";
import paths from "../../../paths.ts";
import { IFrame } from "core/components/iframe/index.ts";

export const DashboardPage: React.FC = () => {
  const { user } = useStateContext();
  const [searchParams] = useSearchParams();

  const ctx = searchParams.get("ctx");

  if (user?.isSingleAdHocAccount && !ctx) {
    return <Navigate to={`/${paths.authenticated.PROJECTS}`} />;
  }

  if (user?.isSingleAdHocAccount && ctx) {
    return <AdHocDashboard contextId={ctx} />;
  }

  return <OrganizationDashboardPage />;
};

const OrganizationDashboardPage = () => {
  const result = useGetQuickSightOrg();

  return <IFrame.Query query={result} />;
};
